package tta.destinigo.talktoastro.version_info

import tta.destinigo.talktoastro.shared.data.VersionInfo

actual fun getAppVersionInfo(): VersionInfo {
    return VersionInfo(
        versionName = "21.52.50",
        versionCode = 66
    )
}